import React from "react";
import { PropTypes } from "prop-types";

export class AMPComponent extends React.Component {

    constructor(props) {
        super(props);
        this.targetElement = null;
    }

    componentDidMount() {
        if (this.targetElement) {
            const {applicationId, applicationVersion} = this.props;
            window.$amp.startApplicationVersion(applicationId, applicationVersion, this.targetElement);
        }
    }

    render() {
        return <div ref={element => this.targetElement = element}/>;
    }

}

AMPComponent.propTypes = {
    applicationId: PropTypes.string.isRequired,
    applicationVersion: PropTypes.string
};

AMPComponent.defaultProps = {
    applicationVersion: 'latest'
};



// WEBPACK FOOTER //
// ./components/amp/index.jsx